export default __webpack_public_path__ + "static/media/Rihan.51e0be97.jpg";